const resourceModal = document.getElementById("resource-modal");

if (resourceModal) {
  const resourceListing = document.querySelectorAll(".resource-listing");
  const modalTitle = resourceModal.querySelector("h3.modal-title");
  const closeResourceModal = resourceModal.querySelector(
    "#close-resource-modal"
  );
  closeResourceModal.addEventListener("click", function (e) {
    if(document.querySelector("#gform_confirmation_wrapper_5")) {
      $( '#gform_confirmation_wrapper_5' ).parent().data( 'gwrf_5' ).reloadForm();
    }
    closeModal();
  });

  function openModal() {
    modalTitle.classList.remove("text-orange");
    modalTitle.innerHTML = "Download Product Data Sheet";
    resourceModal.classList.remove("hidden");
  }

  function closeModal() {
    resourceModal.classList.add("hidden");
  }

  function handleClick(item) {
    console.log("item", item);
    item.preventDefault();
    item.stopPropagation();
    const li = item.target.closest("li");
    if(!li) return;
    if (li.classList.contains("has-pdf")) {
      const url = li.dataset.url;
      console.log("url", url);
      if(document.querySelector("input#input_5_14")) {
        document.querySelector("input#input_5_14").value = url;
      }
      openModal();
    } else {
      window.location.href = li.querySelector("a").href;
    }
  }

  // intercept clicks on resource listing
  resourceListing.forEach(listing => {
    listing.addEventListener("click", function (e) {
      handleClick(e);
    });
  });
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    // code to be triggered when the confirmation page is loaded
    modalTitle.textContent =
      "Thank you for your product data request. One of our representatives will get back to you shortly.";
    modalTitle.classList.add("text-orange");
  });
}
